import React from "react";

// Elegant inline SVG social glyphs, consistent stroke weight.
const base = { width: 20, height: 20, viewBox: "0 0 24 24", "aria-hidden": true };

export function InstagramIcon(props) {
  return (
    <svg {...base} {...props} fill="none">
      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="17.2" cy="6.8" r="1" fill="currentColor" />
    </svg>
  );
}

export function TikTokIcon(props) {
  return (
    <svg {...base} {...props} fill="none">
      <path
        d="M13.2 3.5v10.9a3.1 3.1 0 1 1-2.6-3.06"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2 3.5c.4 2.2 1.9 3.8 4.1 4.1"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FacebookIcon(props) {
  return (
    <svg {...base} {...props} fill="none">
      <path
        d="M14.5 8.5h1.8V5.9c-.3 0-1.4-.1-2.4-.1-2.4 0-3.6 1.4-3.6 3.6v1.6H8v2.6h2.3V21h2.8v-7.8h2.2l.4-2.6h-2.6V9.6c0-.7.2-1.1 1.4-1.1Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
